export default __webpack_public_path__ + "static/media/slide2.5c124bc2.jpg";